export const getAllLessons = (state) => state.lesson.lessons;
export const getIsLoading = (state) => state.lesson.isLoading;
